import { BaseException, BaseExceptionContext } from './base.exception';

interface ServerErrorExceptionContext extends BaseExceptionContext {}

export class ServerErrorException extends BaseException {
  constructor(entity: string, context: ServerErrorExceptionContext) {
    super(`Server error occurred while processing ${entity}`, context);
  }
}
